export const pythonFaqs = [
    {
        id: "python-faq-1",

        question: "Can I start learning without paying?",

        answer:
            "Yes! We offer the first few classes completely free. You can explore the course, experience our teaching style, and decide later if you’d like to upgrade to the advanced modules or project-based training.",
    },

    {
        id: "python-faq-2",

        question: "How do I get started?",

        answer:
            "Just click on “Start Free Classes Now” and register. You’ll instantly get access to the free content and updates about upcoming sessions. No credit card or payment required to begin.",
    },

    {
        id: "python-faq-3",

        question: "How much does the course cost?",

        answer:
            "The introductory classes are free. You only pay for advanced modules or project training. Fees are affordable and structured per module.",

        link: {
            text: "Download Brochure / Contact Us",
            url: "#contact",
        },
    },

    {
        id: "python-faq-4",

        question:
            "Do I need any prior programming knowledge to learn Python?",

        answer:
            "No prior programming experience is required. Our course starts from the basics and gradually moves to advanced concepts.",
    },

    {
        id: "python-faq-5",

        question:
            "What are the career opportunities after learning Python?",

        answer:
            "Python opens opportunities across several technology roles, including:",

        list: [
            "Software Development",
            "Web Development",
            "Data Science",
            "Machine Learning",
            "Automation Testing",
            "DevOps & more",
        ],
    },

    {
        id: "python-faq-6",

        question: "Will I get hands-on experience?",

        answer:
            "Yes. We focus on project-based learning. You’ll build real-time projects to understand practical implementation.",
    },

    {
        id: "python-faq-7",

        question:
            "Will I get support if I have doubts after class hours?",

        answer:
            "Absolutely! We provide doubt-clearing sessions and post-class support via chat, calls, and email.",
    },

    {
        id: "python-faq-8",

        question: "Do I get a certificate after completion?",

        answer:
            "Yes, a course completion certificate will be provided, which is helpful for your resume and job interviews.",
    },

    {
        id: "python-faq-9",

        question:
            "What tools or IDEs will I use during this course?",

        answer:
            "You’ll learn to work with:",

        list: [
            "Python (latest version)",
            "Jupyter Notebook",
            "VS Code / PyCharm",
            "GitHub for version control",
        ],
    },

    {
        id: "python-faq-10",

        question:
            "What tools or software do I need?",

        answer:
            "All you need is a computer with internet access. We’ll guide you through installing free tools like Python, Jupyter Notebook, VS Code, and other libraries. No paid software is required.",
    },

    {
        id: "python-faq-11",

        question:
            "Are you looking to hire candidates for companies?",

        answer:
            "Yes, we specialize in helping businesses find and hire the right talent. Our HR and recruitment services are tailored to meet your company’s specific hiring needs. Contact us to learn how we can support your hiring process.",

        link: {
            text: "WoCons – Custom AI & CAD Solutions",
            url: "https://wocons.com/",
        },
    },
];